import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { api } from '../api';

export const useWishlist = (user) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!user) { setItems([]); return; }
    api.get('/wishlist').then((res) => setItems(res.data)).catch(() => {});
  }, [user]);

  const has = useCallback(
    (type, id) => items.some((w) => w.item_type === type && w.item_id === id),
    [items]
  );

  const toggle = useCallback(async (type, id) => {
    if (!user) {
      toast.info('Login to save trips to your wishlist');
      navigate('/login');
      return;
    }
    try {
      const res = has(type, id)
        ? await api.delete(`/wishlist/${type}/${id}`)
        : await api.post('/wishlist', { item_type: type, item_id: id });
      setItems(res.data);
      toast.success(has(type, id) ? 'Removed from wishlist' : 'Saved to your wishlist');
    } catch (e) {
      toast.error('Could not update wishlist');
    }
  }, [user, has, navigate]);

  return { items, has, toggle, setItems };
};
